import {BatteryCharging} from 'lucide-react'

function Footer() {
  return (
    <footer className="relative bg-slate-900 text-bone pt-20 pb-10 overflow-hidden">
      <div className="absolute inset-0 grain opacity-15 pointer-events-none" />
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Mega mark */}
        <div className="border-y border-white/10 py-12 mb-10">
          <div className="font-display text-[clamp(3rem,12vw,11rem)] leading-[0.85] font-medium tracking-tight" style={{ color: '#FAF8F5' }}>
            saving<span className="italic font-light text-amber-400">battery</span>.com
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-8 h-8 rounded-md bg-amber-400 flex items-center justify-center">
                <BatteryCharging className="w-4 h-4 text-slate-900" strokeWidth={2.2} />
              </div>
              <span className="font-display text-[17px] font-semibold" style={{ color: '#FAF8F5' }}>Saving Battery Hub</span>
            </div>
            <p className="text-slate-400 text-[13.5px] leading-relaxed max-w-xs">
              An independent, ad-free reference for extending the lifespan of your everyday devices. No telemetry. No accounts.
            </p>
          </div>

          <div>
            <div className="font-mono text-[10.5px] uppercase tracking-[0.22em] text-slate-500 mb-4">Index</div>
            <ul className="space-y-2.5 text-[13.5px] text-slate-300">
              <li><a href="#calculator" className="hover:text-amber-400 transition">Battery Calculator</a></li>
              <li><a href="#hubs" className="hover:text-amber-400 transition">Device Hubs</a></li>
              <li><a href="#faq" className="hover:text-amber-400 transition">Frequently Asked</a></li>
            </ul>
          </div>

          <div>
            <div className="font-mono text-[10.5px] uppercase tracking-[0.22em] text-slate-500 mb-4">Legend</div>
            <ul className="space-y-2.5 text-[13.5px] text-slate-300 font-mono">
              <li className="flex items-center gap-2"><span className="w-2 h-2 rounded-full bg-emerald-400" /> Verified by reviewers</li>
              <li className="flex items-center gap-2"><span className="w-2 h-2 rounded-full bg-amber-400" /> Manufacturer-recommended</li>
              <li className="flex items-center gap-2"><span className="w-2 h-2 rounded-full bg-slate-500" /> Niche-condition only</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 font-mono text-[11px] text-slate-500">
          <div>© {new Date().getFullYear()} Saving Battery Hub. Built for longevity.</div>
          <div>v2.04 · Last calibration {new Date().toLocaleDateString('en-US', { month: 'short', year: 'numeric' })}</div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
